// extracted by mini-css-extract-plugin
export default {"content":"Tooltip_content__jzSUk","trigger":"Tooltip_trigger__wYlme","arrow":"Tooltip_arrow__BO7XL","popover":"Tooltip_popover__Ukqia","popoverArrow":"Tooltip_popoverArrow__nktRl"};